import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import { Button, Row, Col, Label, Input, InputGroup, FormFeedback, InputGroupAddon, InputGroupText } from 'reactstrap';
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

import api from "../../../../api";

export default class ModalHabilitarMovil extends Component{
    constructor(props){
        super(props);
        this.state = {
            id: null,
            Nombre:'',
            username:'',
            habilitadoMovil: null,
            errors: []
       };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['HABILITAR_MOVIL']).isRequired,
    }

    resetForm(){
        this.setState({
            id: null,
            Nombre:'',
            username:'',
            habilitadoMovil:false,
            errors: [],
        });
    }

    getData(){
        return {
            habilitadoMovil:this.state.habilitadoMovil
        };
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                username: data.username,
                Nombre: data.Nombre,
                habilitadoMovil: data.habilitadoMovil
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }
    render(){
        const {Nombre, username, habilitadoMovil} = this.state;

        let getUrl = api.gestion.ventas.vendedores.vendedores;
        let submitUrl = api.gestion.ventas.vendedores.vendedorHabilitarMovil;

        return (
            <ParadigmaModal
                getUrl={getUrl}
                submitUrl={submitUrl}
                submitType={"POST"}
                id={this.props.id}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={"Habilitar/Deshabilitar Movil"}

                danger={false}
                buttonClass={"btn-warning"}

                successMessage={"OK"}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={"Guardar"}
                buttonTitle={"Habilitar/Deshabilitar Movil"}
                buttonIcon={"fa fa-mobile fa-lg"}
                saveButton={true}
                closeButton={true}
            >
                <ParadigmaLabeledInput
                    disabled ={true}
                    clearable={false}
                    md={[2, 10]}
                    label={"Vendedor"}
                    value={Nombre }
                />
                <ParadigmaLabeledInput
                    disabled ={true}
                    clearable={false}
                    md={[2, 10]}
                    label={"Username"}
                    value={username}
                />
                <ParadigmaLabeledInput
                    md={[2,10]}
                    label={"Móvil Habilitado"}
                    error={() => this.getError('habilitadoMovil')}
                    inputComponent={
                        <div className="d-flex">
                            <Button
                                disabled={false}
                                className="mr-1 flex-grow-1"
                                color={habilitadoMovil == true ? 'success' : 'secondary'}
                                onClick={() => this.setState({habilitadoMovil:true})}
                            >
                                SI
                            </Button>
                            <Button
                                disabled={false}
                                className="mr-1 flex-grow-1"
                                color={habilitadoMovil  == false? 'danger' : 'secondary'}
                                onClick={() => this.setState({habilitadoMovil:false})}
                            >
                                NO
                            </Button>
                        </div>
                    }
                />

            </ParadigmaModal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Vendedores/ModalHabilitarMovil.js